document.addEventListener('DOMContentLoaded', function () {
  window.currentSelectedSize = '';

  window.updateSizeChart = function (size) {
    window.currentSelectedSize = size;

    updateInlineChart(size);

    updateModalHighlighting(size);
  };

  function updateInlineChart(selectedSize) {
    const inlineContent = document.getElementById('inline-size-chart-content');
    const inlineChart = document.getElementById('inline-size-chart');

    if (!inlineContent || !inlineChart) return;

    if (!selectedSize) {
      inlineChart.style.display = 'none';

      const productSizeModal = document.querySelector('.product-size-modal');
      if (productSizeModal) {
        productSizeModal.style.display = 'flex';
      }
      return;
    }

    const currentUnit = document.querySelector("input[name='unit-toggle']:checked")?.value;
    if (currentUnit) {
      createInlineChartContent(selectedSize, currentUnit);
    }
  }

  function createInlineChartContent(selectedSize, unit) {
    const inlineContent = document.getElementById('inline-size-chart-content');
    const inlineChart = document.getElementById('inline-size-chart');

    if (!inlineContent || !inlineChart) return;

    const chartSelector = `#chart-${unit}`;

    const chartContainer = document.querySelector(chartSelector);

    const modalChart = document.querySelector(chartSelector + ' .size-chart-custom');

    if (!modalChart) {
      inlineChart.style.display = 'none';

      const productSizeModal = document.querySelector('.product-size-modal');
      if (productSizeModal) {
        productSizeModal.style.display = 'flex';
      }
      return;
    }

    const headerElements = modalChart.querySelectorAll('.size-chart-header-value');
    const sizeHeaders = Array.from(headerElements).map((el) => el.textContent.trim());

    const sizeIndex = sizeHeaders.findIndex((size) => size === selectedSize);
    if (sizeIndex === -1) {
      inlineChart.style.display = 'none';
      return;
    }

    const measurementRows = modalChart.querySelectorAll('.size-chart-data-rows .size-chart-row');

    let html = '<div class="inline-chart-table">';

    measurementRows.forEach((row) => {
      const measurementLabel = row.querySelector('.size-chart-label').textContent.trim();
      const valueElements = row.querySelectorAll('.size-chart-value');

      if (valueElements[sizeIndex]) {
        const value = valueElements[sizeIndex].textContent.trim();

        html += '<div class="inline-chart-row">';
        html += `<span class="measurement-label">${measurementLabel} </span>`;
        html += `<span class="measurement-value">${value}</span>`;
        html += '</div>';
      }
    });

    html += '</div>';
    inlineContent.innerHTML = html;
    inlineChart.style.display = 'block';

    const productSizeModal = document.querySelector('.product-size-modal');
    if (productSizeModal) {
      productSizeModal.style.display = 'block';
    }
  }

  function updateModalHighlighting(selectedSize) {
    document.querySelectorAll('.size-highlighted').forEach((el) => {
      el.classList.remove('size-highlighted');
    });

    document.querySelectorAll('[data-size]').forEach((el) => {
      if (el.getAttribute('data-size') === selectedSize) {
        el.classList.add('size-highlighted');
      }
    });
  }

  document.querySelectorAll("input[name='unit-toggle']").forEach((radio) => {
    radio.addEventListener('change', (e) => {
      const selectedUnit = e.target.value;

      document.querySelectorAll('[id^="chart-"]').forEach((chart) => {
        chart.style.display = 'none';
      });

      const activeChart = document.getElementById(`chart-${selectedUnit}`);
      if (activeChart) {
        activeChart.style.display = 'block';
      }

      if (window.currentSelectedSize) {
        createInlineChartContent(window.currentSelectedSize, selectedUnit);
      }

      if (window.currentSelectedSize) {
        updateModalHighlighting(window.currentSelectedSize);
      }
    });
  });
});
